module.exports = __webpack_public_path__ + "img/ic_coins-balance.6dbfaa85.svg";